var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInternetOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6 2.727)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.47 33.207a.662.662 0 0 1-.411-.143C2.573 29.519 0 24.22 0 18.527 0 8.31 8.318 0 18.543 0c10.224 0 18.542 8.311 18.542 18.527 0 5.511-2.44 10.702-6.695 14.242a.665.665 0 1 1-.85-1.023 17.156 17.156 0 0 0 6.215-13.22c0-9.482-7.721-17.196-17.212-17.196C9.05 1.33 1.33 9.044 1.33 18.527c0 5.284 2.388 10.202 6.553 13.493a.665.665 0 0 1-.413 1.187z",
    fill: "#01A36D"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#9AC9FF",
    cx: 18.543,
    cy: 18.527,
    rx: 15.152,
    ry: 15.139
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.543 3.388c-.6 0-1.192.036-1.774.103 7.533.878 13.38 7.274 13.38 15.036 0 7.761-5.847 14.158-13.38 15.035.582.068 1.174.104 1.774.104 8.368 0 15.152-6.778 15.152-15.14 0-8.36-6.784-15.138-15.152-15.138z",
    fill: "#68A0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.048 25.027c-1.681-.958-3.795-1.707-6.168-2.209.178-1.36.273-2.798.273-4.291 0-1.493-.095-2.932-.273-4.292 2.373-.502 4.487-1.25 6.168-2.208a.665.665 0 1 0-.658-1.156c-1.552.884-3.507 1.579-5.713 2.051-1.067-6.016-3.822-10.2-7.134-10.2-3.313 0-6.068 4.184-7.135 10.2-2.206-.472-4.161-1.166-5.713-2.05a.665.665 0 0 0-.659 1.155c1.682.958 3.796 1.706 6.17 2.209a33.1 33.1 0 0 0-.274 4.29c0 1.494.095 2.932.273 4.292-2.373.503-4.487 1.25-6.169 2.209a.665.665 0 0 0 .659 1.155c1.552-.884 3.507-1.578 5.713-2.05 1.067 6.016 3.822 10.199 7.134 10.199 3.313 0 6.068-4.183 7.135-10.2 2.206.473 4.16 1.167 5.713 2.051a.665.665 0 0 0 .658-1.155zM14.236 8.099c1.18-2.572 2.75-4.046 4.307-4.046 1.557 0 3.127 1.474 4.306 4.046.672 1.465 1.185 3.19 1.52 5.072a35.452 35.452 0 0 1-5.827.468 35.45 35.45 0 0 1-5.825-.468c.334-1.883.846-3.607 1.519-5.072zm-1.974 10.428c0-1.388.087-2.746.254-4.043 1.898.317 3.933.485 6.026.485 2.094 0 4.129-.168 6.027-.486.167 1.298.254 2.655.254 4.044 0 1.388-.087 2.745-.254 4.043a36.703 36.703 0 0 0-6.026-.485c-2.094 0-4.129.168-6.027.485a31.67 31.67 0 0 1-.254-4.043zm10.587 10.428C21.67 31.526 20.1 33 18.543 33c-1.558 0-3.128-1.475-4.307-4.046-.672-1.466-1.185-3.19-1.52-5.073a35.454 35.454 0 0 1 5.827-.468c2.03 0 3.998.162 5.825.468-.334 1.883-.846 3.607-1.519 5.073z",
    fill: "#B9D7FA"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.208 30.8)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#F9F7F8",
    cx: 8.335,
    cy: 8.328,
    rx: 8.335,
    ry: 8.328
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.335 0c-.609 0-1.202.066-1.773.19 3.751.812 6.562 4.146 6.562 8.138 0 3.99-2.81 7.326-6.562 8.138.571.124 1.164.19 1.773.19 4.603 0 8.335-3.73 8.335-8.328C16.67 3.728 12.938 0 8.335 0z",
    fill: "#E7E6E6"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#01A36D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.704 10.936a.67.67 0 0 0-.938.21.67.67 0 0 0 .2.896.671.671 0 0 0 .938-.21.67.67 0 0 0-.2-.896zM5.47 8.917a.665.665 0 1 0 .94.94 2.728 2.728 0 0 1 3.85 0 .663.663 0 0 0 .94 0c.26-.26.26-.68 0-.94a4.06 4.06 0 0 0-5.73 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.286 6.579c-2.73-2.728-7.172-2.728-9.902 0a.665.665 0 0 0 .94.94 5.683 5.683 0 0 1 8.022 0 .663.663 0 0 0 .94 0c.26-.26.26-.68 0-.94z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternetOn);
export default __webpack_public_path__ + "static/media/internet-on.4938ef48e7b07bc8ae5d4d964d3f1121.svg";
export { ForwardRef as ReactComponent };